import { AxiosResponse } from 'axios';
import ABSMessage from '../../../components/ABSMessage';
import routeConfig from '../../../abs/config/routeConfig';
import authService from '../../../abs/services/auth/authService';
import EventEmitter, { EventName, EventMessage } from '../../eventUtils';

class HttpHelpers {
  /**
   * 请求超时设置
   *
   * @param {number} requestTimeout 请求超时时间
   * @returns {Promise<any>} Promise
   */
  static timeout(requestTimeout: number): Promise<any> {
    requestTimeout = requestTimeout;
    return new Promise((resolve, reject) => {
      setTimeout(() => reject(new Error('网络请求超时')), requestTimeout);
    });
  }

  /**
   * 检查返回信息
   * @param response
   */
  static checkStatus(response: any) {
    if (response.status >= 200 && response.status < 300) {
      // 非法的用户
      if (response.status === 206) {
        EventEmitter.emit(EventName[206], EventMessage[206]);
        return null;
      }

      let statusCode = response.data.status_code || response.data.code;

      if (statusCode !== 200) {
        if (statusCode === 401) {
          authService.removeAllCache();
          if (window.location.href && window.location.href.indexOf('return_url') < 0 && window.location.href.indexOf('login') < 0) {
            location.href = routeConfig.login + '?return_url=' + encodeURIComponent(window.location.href);
          }
          return;
        }

        if (statusCode === 402) {
          // TODO： 多点登录提示信息
          authService.removeAllCache();
          if (window.location.href && window.location.href.indexOf('return_url') < 0 && window.location.href.indexOf('login') < 0) {
            location.href =
              routeConfig.login + '?return_url=' + encodeURIComponent(window.location.href) + '&message=相同账号在其他地点登录，您已被迫退出';
          }
          return;
        }

        if (statusCode === 403) {
          location.href = routeConfig.home;
          return;
        }

        if (statusCode === 500) {
          ABSMessage.error(response.data.error_message || response.data.message);
          return;
        }
      } else {
        return response;
      }
    }

    ABSMessage.error('服务器或网络异常，请稍后再试');
    return null;
  }

  /**
   * 处理响应数据
   *
   * @param {AxiosResponse<any>} response 请求响应
   * @returns {Promise<any>} Promise
   */
  static parseResponse(response: AxiosResponse<any>): Promise<any> {
    return new Promise(
      (resolve: any, reject: any): void => {
        if (response && response.data.code === 200 && response.data) {
          // 记录服务端响应数据
          let serverResponseData;
          if (typeof response.data === 'object' && response.data.hasOwnProperty('data')) {
            serverResponseData = response.data;
          } else if (typeof response.data === 'string') {
            try {
              // try parse json
              serverResponseData = JSON.parse(response.data);
            } catch (e) {
              // nothing to do
            }
          }
          // handle data or error
          if (serverResponseData && typeof serverResponseData === 'object') {
            if (serverResponseData.status === 'ok' && serverResponseData.hasOwnProperty('data')) {
              resolve(serverResponseData.data);
              return;
            }

            ABSMessage.error(serverResponseData.data || serverResponseData.message);
            resolve(null);
            if (serverResponseData.data === '请求的资源不存在') {
              setTimeout(() => {
                location.href = routeConfig.home;
              }, 3000);
            }
          }
        }
        resolve(null);
      }
    );
  }
}

export default HttpHelpers;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/utils/http/request/helper.ts